/**
 * src/utils/audioObjectUrl.ts
 *
 * Synthesised speech arrives base64-encoded and `<audio>` wants a URL.
 *
 * A `blob:` URL rather than `data:audio/…;base64,…`, because the two
 * would need different CSP grants and `blob:` is the narrower one — the
 * `data:` form was blocked outright once `media-src` was tightened.
 */

export function objectUrlForAudio(base64: string, mime?: string | null): string | null {
  try {
    const bin = atob(base64);
    const buf = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i += 1) buf[i] = bin.charCodeAt(i);
    return URL.createObjectURL(new Blob([buf], { type: mime || 'audio/mpeg' }));
  } catch {
    return null;
  }
}
